import apiService from './apiService';

export type ScheduledEmailStatus =
  | 'planned'
  | 'created'
  | 'verified'
  | 'scheduled'
  | 'sent'
  | 'canceled';

export type ScheduledEmailPlatform = 'mautic' | 'brevo' | 'other';

export interface ScheduledEmail {
  id: number;
  client_id: number;
  client_name: string | null;
  subject: string;
  send_date: string;                  // ISO datetime
  promised_by_date: string | null;    // ISO date
  status: ScheduledEmailStatus;
  platform: ScheduledEmailPlatform;
  platform_link_url: string | null;
  owner_user_id: number | null;
  owner_email: string | null;
  audience: string | null;
  notes: string | null;
  estimated_recipients: number | null;
  last_status_change_at: string | null;
  last_status_change_by: number | null;
  created_by: number | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface ScheduledEmailInput {
  client_id: number;
  subject: string;
  send_date: string;
  promised_by_date?: string | null;
  status?: ScheduledEmailStatus;
  platform?: ScheduledEmailPlatform;
  platform_link_url?: string | null;
  owner_user_id?: number | null;
  audience?: string | null;
  notes?: string | null;
  estimated_recipients?: number | null;
}

export interface ListParams {
  from?: string;   // YYYY-MM-DD
  to?: string;     // YYYY-MM-DD
  client_id?: number;
  status?: ScheduledEmailStatus;
}

export const listScheduledEmails = async (params: ListParams = {}) => {
  const res = await apiService.get<ScheduledEmail[]>('/api/scheduled-emails', { params });
  return res.data;
};

export const createScheduledEmail = async (data: ScheduledEmailInput) => {
  const res = await apiService.post<ScheduledEmail>('/api/scheduled-emails', data);
  return res.data;
};

export const updateScheduledEmail = async (id: number, data: Partial<ScheduledEmailInput>) => {
  const res = await apiService.put<ScheduledEmail>(`/api/scheduled-emails/${id}`, data);
  return res.data;
};

export const transitionStatus = async (id: number, status: ScheduledEmailStatus) => {
  const res = await apiService.patch<ScheduledEmail>(
    `/api/scheduled-emails/${id}/status`,
    { status }
  );
  return res.data;
};

export const deleteScheduledEmail = async (id: number) => {
  await apiService.delete(`/api/scheduled-emails/${id}`);
};
